import TaxReturnForm from 'app/modules/FormDefinition/components/Form';
import { type TaxReturn } from 'app/modules/Reports/TaxReturnList/types';

export const BodyPreview = ({ taxreturn }: { taxreturn: TaxReturn }) => {
  return (
    <TaxReturnForm
      readOnly={true}
      submit={() => {}}
      defaultValue={taxreturn?.cells}
      version={taxreturn.formVersionId}
    />
  );
};
